// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Badge$Showside from "./Badge.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as CartAnimation$Showside from "./CartAnimation.bs.js";
import * as IconCartFilled$Showside from "../icons/IconCartFilled.bs.js";
import * as QuickViewButton$Showside from "./QuickViewButton.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseCheckoutAction$Showside from "../hook/UseCheckoutAction.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function QuickViewCheckoutButton(Props) {
  var colorOpt = Props.color;
  var color = colorOpt !== undefined ? colorOpt : /* Clear */2;
  EntrypointContext$Showside.use(undefined);
  var match = CartContextProvider$Showside.useCart(undefined);
  ConfigurationProvider$Showside.use(undefined);
  ViewportContext$Showside.use(undefined);
  var tmp = {
    className: CSS$Showside.prefix("top-px right-px"),
    dataTestId: "cart-total-count"
  };
  var tmp$1 = StringUtils$Showside.fromInt(99, undefined, match.cart.itemCount);
  if (tmp$1 !== undefined) {
    tmp.text = tmp$1;
  }
  var badge = React.createElement(Badge$Showside.make, tmp);
  var icon = React.createElement(IconCartFilled$Showside.make, {
    className: CSS$Showside.prefix("w-8 h-8")
  });
  var match$1 = UseCheckoutAction$Showside.useCheckoutAction(undefined);
  var checkoutOnClick = match$1.onClick;
  var checkoutHref = match$1.href;
  if (checkoutHref === undefined && checkoutOnClick === undefined) {
    return null;
  }
  var tmp$2 = {
    color: color,
    className: CSS$Showside.prefix(Cn.make(["items-center justify-center leading-none relative w-13 h-13 rounded-full", "pointer-events-auto"])),
    children: null,
    block: false,
    flex: true,
    dataTestId: "qv-button-checkout"
  };
  if (checkoutOnClick !== undefined) {
    tmp$2.onClick = Caml_option.valFromOption(checkoutOnClick);
  }
  if (checkoutHref !== undefined) {
    tmp$2.href = Caml_option.valFromOption(checkoutHref);
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
    className: CSS$Showside.prefix("relative pointer-events-auto")
  }, React.createElement(QuickViewButton$Showside.make, tmp$2, badge, icon, React.createElement(CartAnimation$Showside.make, {
    productDirection: /* Bottom */1,
    tooltipDirection: /* Left */2,
    className: CSS$Showside.prefix("absolute w-full h-full")
  }))));
}
QuickViewCheckoutButton.displayName = "QuickViewCheckoutButton";
var make = QuickViewCheckoutButton;
export { make };
/* react Not a pure module */